// extracted by mini-css-extract-plugin
export default {"container":"HtmlRenderer_container__0eSfL","iframe":"HtmlRenderer_iframe__dWWA+"};